import { render, staticRenderFns } from "./SuggestionInput.vue?vue&type=template&id=92e48958&scoped=true&"
import script from "./SuggestionInput.vue?vue&type=script&lang=js&"
export * from "./SuggestionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e48958",
  null
  
)

export default component.exports